import get from 'lodash/get'
import moment from 'moment'
import React from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import Modal from '../../../common/modal/Modal'
import { i18n } from '../../index'
import withActiveStation, { WithActiveStationProps } from '../../station/withActiveStation'
import ProductTypeSelector, { DEFAULT_PRODUCT_TYPE, ProductType } from '../common/ProductTypeSelector'
import { DailySalesNote } from '../customerSales/CustomerSalesTable'
import MonthDisplay from './MonthDisplay'
import WastageGraph from './WastageGraph'
import { fetchReportMonthlyWastage } from './WastageQueries'
import WastageTable from './WastageTable'
import { WastageNote } from './types'
import css from './wastage.css'

type Props = {} & WithActiveStationProps

type State = {
  productType: ProductType
  selectedDate: moment.Moment
  spotlight?: WastageNote
}

type QueryResult = {
  reportMonthlyWastage: DailySalesNote[]
  getWastageBoundariesForProductType: {
    id: string
    productType: string
    lowerWastageBounds: number
    upperWastageBounds: number
  }
  stationSettings: {
    id: string
    category: string
    name: string
    type: string
  }[]
}

@withActiveStation
class Wastage extends React.Component<Props, State> {
  state = {
    productType: DEFAULT_PRODUCT_TYPE,
    selectedDate: moment(),
    spotlight: undefined,
  }
  clearSpotlight = () => {
    this.setState({
      spotlight: undefined,
    })
  }
  setSpotlight = (data: WastageNote) => () => {
    this.setState({
      spotlight: data,
    })
  }
  onProductTypeChange = (option: any) => {
    this.setState({
      productType: option.value,
    })
  }
  onMonthChange = (step: number) => {
    this.setState((prevState) => ({
      selectedDate: prevState.selectedDate.add(step, 'months'),
    }))
  }

  render() {
    const { activeStation } = this.props
    const { productType, selectedDate, spotlight } = this.state
    const monthName = moment(selectedDate).format('MMMM')
    const monthNumber = moment(selectedDate).format('MM')
    const year = moment(selectedDate).format('YYYY')
    return (
      <React.Fragment>
        <Query<QueryResult, any>
          query={fetchReportMonthlyWastage}
          variables={{
            stationId: activeStation && activeStation.id,
            type: productType,
            productType: productType.toLowerCase(),
            year: Number(year),
            month: Number(monthNumber),
          }}
        >
          {({ loading, error, data }) => (
            <>
              <span className={css.label}>{i18n.t('reporting.productGroup')}</span>
              <ProductTypeSelector
                onChange={this.onProductTypeChange}
                value={productType}
                stationSettings={data.stationSettings}
                overridePizzaTable={true}
              />
              <MonthDisplay selectedMonth={`${monthName} ${year}`} onMonthChange={this.onMonthChange} />
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <Modal spotlight={spotlight} clearSpotlight={this.clearSpotlight} />
                <WastageTable
                  activeStation={activeStation}
                  wastageData={get(data, 'getWastageBoundariesForProductType', {})}
                  data={get(data, 'reportMonthlyWastage', [])}
                  handleSelectNote={this.setSpotlight}
                />
                <WastageGraph month={Number(monthNumber)} year={Number(year)} data={data as QueryResult} />
              </Loader>
            </>
          )}
        </Query>
      </React.Fragment>
    )
  }
}

export default Wastage
